import { func, node, oneOfType, string } from 'prop-types';

export const ComponentShape = oneOfType([string, node, func]);
